import { BottomNavigation } from '@features/ui';
import { ChartIcon, GlobalIcon } from '@features/ui/icons';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet } from 'react-router-dom';
import { useGetMe } from '@hooks/useGetMe.ts';

export const AuthLayout = () => {
  const { t } = useTranslation();
  const { me } = useGetMe();

  if (me?.id) {
    if (!me?.complete_onboarding) {
      return <Navigate replace={true} to={'/select-trading-platform'} />;
    }

    return <Navigate replace={true} to={'/'} />;
  }

  return (
    <div className="max-w-7xl m-auto p-6 md:p-8 xl:p-12 min-h-screen flex justify-center flex-col relative">
      <div className="flex justify-between items-center lg:gap-x-12 xl:gap-x-20 flex-col lg:flex-row mb-12">
        <div className="mb-8 lg:mb-0">
          <div className="mb-8 lg:mb-[68px] xl:mb-[88px]">
            <img
              alt="leeloo-logo"
              className="mb-4 lg:mb-6"
              src="/assets/logo.svg"
            />
            <h3 className="text-3xl lg:text-4xl font-bold">
              {t('common.becomeTrader')}
              <span className="text-primary"> {t('common.leeloo')}.</span>
            </h3>
          </div>
          <div className="flex flex-col gap-y-2 lg:gap-y-4 mb-10 lg:mb-[58px]">
            <ChartIcon />
            <p className="text-xl font-medium">
              {t('common.leelooTradingOffer')}
            </p>
          </div>
          <div className="flex flex-col gap-y-2 lg:gap-y-4">
            <GlobalIcon />
            <p className="text-xl font-medium">
              {t('common.worldWideSupport')}
            </p>
          </div>
        </div>
        <Outlet />
      </div>
      <div className={'absolute bottom-4'}>
        <BottomNavigation />
      </div>
    </div>
  );
};
